import api from "./api";

export const principalApis = {
  // ================= PRINCIPAL APIS =================
  getPrincipals: () => api.get("/ncsc-principles_list/"),
  createPrincipal: ({ text }) => api.post("/ncsc-principle/", { text }),
  getPrincipalById: (id) => api.get(`/ncsc-principals/${id}`),
  updatePrincipal: (id, { text }) =>
    api.put(`/ncsc-principle/${id}/`, { text }),
  deletePrincipal: (id) => api.delete(`/ncsc-principle/delete/${id}`),

  // ================= CATEGORY APIS =================
  getCategory: () => api.get("/categories_list/"),
  deleteCategory: (id) => api.delete(`/category/delete/${id}/`),
  createCategory: ({ principle_id, text }) =>
    api.post("/category/", { principle_id, text }),
  updateCategory: (id, { principle_id, text }) =>
    api.put(`/category/${id}/`, { principle_id, text }),

  // ================= METRIC APIS =================
  getMetric: () => api.get("/metrics_list/"),
  deleteMetric: (id) => api.delete(`/metric/delete/${id}`),
  createMetric: ({ category_id, text, sequence_no }) =>
    api.post("/metric/", { category_id, text, sequence_no }),
  updateMetric: (id, { category_id, text, sequence_no }) =>
    api.put(`/metric/${id}/`, { category_id, text, sequence_no }),

  // ================= INDICATOR APIS =================
  getIndicator: () => api.get("/indicators_list/"),
  deleteIndicator: (id) => api.delete(`/indicator/delete/${id}/`),
  createIndicator: ({ question, target, notes, metric_id, sequence_no }) =>
    api.post("/indicator/", {
      question,
      target,
      notes,
      metric_id,
      sequence_no,
    }),
  updateIndicator: (id, { question, target, notes, metric_id, sequence_no }) =>
    api.put(`/indicator/${id}/`, {
      question,
      target,
      notes,
      metric_id,
      sequence_no,
    }),
};
